import { BASE_URL } from '../../../utils/config.base-url'

export const URL_ENDPOINT_LIST_ROLE = `${BASE_URL}/list-role`

export type ListRoleCode =
  | 'lms-admin'
  | 'hr-cham-cong'
  | 'quyen-tao-tin-tuc'
  | 'admin-dao-tao-noi-bo'
  | 'system-admin'
  | 'admin-kpi'
  | 'admin-tai-san'
  | 'admin-giao-viec'
  | 'create-project-no-department'
  | 'admin-phong-hop'
  | 'admin-xe'
  | 'admin-cap-phat-trang-thiet-bi'

export const mapListRoleCode: Record<ListRoleCode, string> = {
  'hr-cham-cong': 'HR',
  'lms-admin': 'LMS Admin',
  'quyen-tao-tin-tuc': 'Người dùng được tạo Tin tức & Sự kiện',
  'admin-dao-tao-noi-bo': 'Admin quản lý đào tạo',
  'system-admin': 'Super Admin',
  'admin-kpi': 'KPI Admin',
  'admin-tai-san': 'Admin quản lý tài sản',
  'admin-giao-viec': 'Admin quản lý giao việc',
  'create-project-no-department': 'Người dùng được tạo dự án chung',
  'admin-phong-hop': 'Admin đặt phòng họp',
  'admin-xe': 'Admin đặt xe',
  'admin-cap-phat-trang-thiet-bi': 'Admin cấp phát trang thiết bị',
}
